import { Email } from '@/components/common/text_input/Email';
import { NewReviewerInvitationEmailRequestDto } from '@/models/Admin/Emails/EmailRequestDtos';
import { userTypeAsString, UserType } from '@/models/User';
import { FormControl, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';
import React from 'react';

type Props = {
  form: NewReviewerInvitationEmailRequestDto;
  setForm: React.Dispatch<React.SetStateAction<NewReviewerInvitationEmailRequestDto>>;
  userTypeOptions: UserType[];
};

const NewReviewerInvitationForm: React.FC<Props> = ({ form, setForm, userTypeOptions }) => {
  return (
    <Stack spacing={2}>
      <Email
        fullWidth
        required
        label='Email'
        value={form.Email}
        onChange={(e) => setForm((prev) => ({ ...prev, Email: e.target.value }))}
      />
      <FormControl fullWidth>
        <InputLabel id='reviewer-role-label' required>
          User Role
        </InputLabel>
        <Select
          labelId='reviewer-role-label'
          value={String(form.UserRole)}
          label='User Role'
          onChange={(e) =>
            setForm((prev) => ({
              ...prev,
              UserRole: Number(e.target.value),
            }))
          }
        >
          {userTypeOptions.map((userType) => (
            <MenuItem key={userType} value={String(userType)}>
              {userTypeAsString(userType)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        fullWidth
        required
        label='Full Name'
        value={form.FullName}
        onChange={(e) => setForm((prev) => ({ ...prev, FullName: e.target.value }))}
      />
    </Stack>
  );
};

export default NewReviewerInvitationForm;
